import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from '../../utilities/validation';

export default class FormErrors extends React.Component {

    render() {
        const {errors} = this.props;

        return (
            <div className="form-errors-from-backend">
                {
                    !isEmpty(errors) && (
                        Object.values(errors).map((err, idx) => (
                            <div key={idx} className="alert alert-danger">{err}</div>
                        ))
                    )
                }
            </div>
        );
    }
}

FormErrors.propTypes = {
    errors: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/common/FormErrors.js